import ajaxapi from "../api/api.js";
import axios from './request.js';

export function isSign() {
    var ajaxUrl = ajaxapi.common.ProductNotice.IsSign();
    // ✅ 关键：return 整个 Promise
    return axios.get(ajaxUrl).then(function(res) {
        console.log('签约状态', res);
        if (res && res.success) {
            // 接口返回：{success: true, data: {isSigned: true/false}}
            return res.data.isSigned;
        } else {
            return Promise.reject(new Error((res && res.message) || '签约状态获取失败'));
        }
    }).catch(function(err) {
        console.error('获取签约状态出错:', err);
        return Promise.reject(err);
    });
}

export function signNotice() { 
    var ajaxUrl = ajaxapi.common.ProductNotice.Sign();
    return axios.post(ajaxUrl, {accepted:'同意'}, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then(function(res) {
        if (res && res.success) {
            return res.data;
        } else {
            return Promise.reject(new Error((res && res.message) || '签约失败'));
        }
    }).catch(function(err) {
        console.error('签约出错:', err);
        return Promise.reject(err);
    });
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

// 精确到时分，格式：202608251601
export function getTimestamp() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hour = String(now.getHours()).padStart(2, '0');
  const minute = String(now.getMinutes()).padStart(2, '0');
  
  return `${year}${month}${day}${hour}${minute}`;
}